(function(){
  'use strict';
  var home=document.getElementById('pt-forest-home');
  if(!home)return;

  var codeForm=home.querySelector('.ptf-code-form');
  if(codeForm){
    var codeInput=codeForm.querySelector('input'),codeError=home.querySelector('#ptf-code-error');
    codeForm.addEventListener('submit',function(event){
      event.preventDefault();
      var code=String(codeInput.value||'').trim().toUpperCase().replace(/[^A-Z0-9]/g,'');
      var valid=/^[A-Z0-9]{6,12}$/.test(code);
      codeError.hidden=valid;codeInput.setAttribute('aria-invalid',String(!valid));
      if(!valid){codeInput.focus();return;}
      window.location.href='/pages/zertifikat?'+encodeURIComponent(code);
    });
    codeInput.addEventListener('input',function(){codeError.hidden=true;codeInput.removeAttribute('aria-invalid');});
  }

  var active='by', map=null, markers={}, ready=false;
  var regions={
    mv:{name:'Landesforst Mecklenburg-Vorpommern',point:[53.749361,11.904306],description:'Mit dem Forstamt Schlemmin unterstützen wir die Waldentwicklung in Mecklenburg-Vorpommern. Die Region begleitet Planet Tree seit den ersten Pflanzungen.',report:'/pages/mv-fruehjahr-2026'},
    by:{name:'Stadtwald Alzenau · Bayern',point:[50.100222,9.068389],description:'Im Stadtwald Alzenau unterstützen wir die Wiederbewaldung geschädigter Flächen und die Entwicklung vielfältiger Wälder.',report:'/pages/bayern-fruehjahr-2026'},
    rp:{name:'Forstrevier Stadtkyll · Eifel',point:[50.313750,6.428444],description:'Im Forstrevier Stadtkyll unterstützen wir die Wiederbewaldung in der Eifel. Unser gemeinsames Engagement ist in den Pflanzberichten dokumentiert.',report:'/pages/eifel-fruehjahr-2026'}
  };
  function track(type,detail){try{if(window.PTAnalytics&&typeof window.PTAnalytics.track==='function')window.PTAnalytics.track(type,detail,{context:{surface:'forest_home'}});}catch(ignore){}}
  function selectRegion(code){
    if(!regions[code])return;active=code;
    home.querySelectorAll('[data-ptf-region]').forEach(function(button){button.setAttribute('aria-pressed',button.dataset.ptfRegion===code?'true':'false');});
    home.querySelector('[data-ptf-region-description]').textContent=regions[code].description;
    home.querySelector('[data-ptf-region-report]').href=regions[code].report;
    if(markers[code])markers[code].openPopup();
    track('home_forest_view',{forest_code:code});
  }
  function start(options){
    var selectedQuick=document.getElementById('pt-quick-b2c');
    if(selectedQuick&&(options.delivery==='print'||options.delivery==='pdf'))selectedQuick.setAttribute('data-ptq-order-preference',options.delivery==='pdf'?'digital':'print');
    var quick=document.getElementById('pt-quick-b2c'),input=quick&&quick.querySelector('[data-ptq-home-start-input]');
    if(!quick||!input){window.location.hash='pt-quick-b2c';return;}
    var resume=quick.querySelector('[data-ptq-beautiful-edit]');
    if(!input.getClientRects().length&&resume&&resume.getClientRects().length){
      resume.click();
      track('home_resume_entry',{kind:'existing_certificate'});
      return;
    }
    var form=quick.querySelector('[data-ptq-home-start-form]');
    if(options.occasion&&form){
      form.setAttribute('data-ptq-pending-occasion',options.occasion);
      var occasion=quick.querySelector('[data-ptq-home-occasion-input]');
      if(occasion){occasion.value=options.occasion;occasion.dispatchEvent(new Event('input',{bubbles:true}));}
      home.querySelectorAll('[data-ptf-occasion]').forEach(function(button){button.setAttribute('aria-pressed',button.dataset.ptfOccasion===options.occasion?'true':'false');});
    }
    if(options.forest){
      var forest=quick.querySelector('[data-ptq-home-forest="'+options.forest+'"]');
      if(forest){quick.setAttribute('data-ptq-forest-chosen','1');forest.click();}
    }
    var message=options.occasion?'Dein Anlass: '+options.occasion+'. Gib oben den Namen für dein Zertifikat ein.':options.forest?'Deine Region: '+regions[options.forest].name+'. Gib oben den Namen für dein Zertifikat ein.':options.delivery==='print'?'Gestalte zuerst dein Zertifikat. Urkundenmappe oder Rahmen wählst du danach mit Preisübersicht.':'Gib den Namen ein und sieh dir deine persönliche Vorschau an.';
    home.querySelector('[data-ptf-selection-note]').textContent=message;
    var cue=quick.querySelector('.ptf-hero-reassurance');if(cue)cue.textContent=message;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    quick.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
    input.focus({preventScroll:true});
    track('home_gift_entry',{kind:options.delivery||'certificate',occasion:options.occasion||'',forest_code:options.forest||''});
  }
  home.addEventListener('click',function(event){
    var target=event.target.closest&&event.target.closest('[data-ptf-region],[data-ptf-choose-region],[data-ptf-occasion],[data-ptf-start]');
    if(!target||!home.contains(target))return;event.preventDefault();
    if(target.hasAttribute('data-ptf-region'))selectRegion(target.dataset.ptfRegion);
    else if(target.hasAttribute('data-ptf-choose-region'))start({forest:active});
    else if(target.hasAttribute('data-ptf-occasion'))start({occasion:target.dataset.ptfOccasion});
    else start({delivery:target.dataset.ptfStart});
  });
  function initMap(){
    if(ready)return;ready=true;
    var box=document.getElementById('ptf-map');if(!box)return;
    function render(){
      if(!window.L)return;
      box.replaceChildren();
      map=window.L.map(box,{scrollWheelZoom:false,zoomSnap:.25,zoomDelta:.5,dragging:!window.matchMedia('(pointer:coarse)').matches,tap:false,zoomControl:true});
      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:17,attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'}).addTo(map);
      map.fitBounds([[47.3,5.9],[54.9,15.1]],{padding:[12,12]});
      Object.keys(regions).forEach(function(code){
        var region=regions[code],popup=document.createElement('div'),strong=document.createElement('strong'),link=document.createElement('a');
        strong.textContent=region.name;link.textContent='Pflanzbericht lesen';link.href=region.report;
        popup.append(strong,document.createElement('br'),link);
        markers[code]=window.L.circleMarker(region.point,{radius:9,color:'#fff8e8',weight:3,fillColor:'#255536',fillOpacity:1}).addTo(map).bindPopup(popup).on('click',function(){selectRegion(code);});
      });
    }
    if(window.L){render();return;}
    var css=document.createElement('link');css.rel='stylesheet';css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';document.head.appendChild(css);
    var script=document.createElement('script');script.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';script.onload=render;script.onerror=function(){track('home_map_unavailable',{});};document.head.appendChild(script);
  }
  var box=document.getElementById('ptf-map');
  if(box&&'IntersectionObserver'in window){var observer=new IntersectionObserver(function(entries){if(entries.some(function(entry){return entry.isIntersecting;})){observer.disconnect();initMap();}},{rootMargin:'250px'});observer.observe(box);}else initMap();
})();
